import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center gap-2" }
const _hoisted_2 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 1,
  class: "d-flex align-items-center gap-1"
}
const _hoisted_6 = { style: {"width":"130px"} }
const _hoisted_7 = { style: {"width":"130px"} }
const _hoisted_8 = {
  key: 2,
  class: "badge bg-info bg-opacity-10 text-info fw-medium fs-11 px-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn btn-sm", _ctx.periodeStore.mode === 'annee' ? 'btn-primary' : 'btn-outline-secondary']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changerMode('annee'))),
        title: "Par année"
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("i", {
          class: "material-symbols-outlined",
          style: {"font-size":"14px","vertical-align":"middle"}
        }, "calendar_today", -1)
      ]))], 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn btn-sm", _ctx.periodeStore.mode === 'plage' ? 'btn-primary' : 'btn-outline-secondary']),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changerMode('plage'))),
        title: "Plage libre"
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("i", {
          class: "material-symbols-outlined",
          style: {"font-size":"14px","vertical-align":"middle"}
        }, "date_range", -1)
      ]))], 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn btn-sm", _ctx.periodeStore.mode === 'tout' ? 'btn-primary' : 'btn-outline-secondary']),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changerMode('tout'))),
        title: "Tout l'historique"
      }, [...(_cache[8] || (_cache[8] = [
        _createElementVNode("i", {
          class: "material-symbols-outlined",
          style: {"font-size":"14px","vertical-align":"middle"}
        }, "all_inclusive", -1)
      ]))], 2)
    ]),
    (_ctx.periodeStore.mode === 'annee')
      ? (_openBlock(), _createElementBlock("select", {
          key: 0,
          value: _ctx.periodeStore.annee,
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.periodeStore.annee = +($event.target as HTMLSelectElement).value)),
          class: "form-select form-select-sm",
          style: {"width":"75px","height":"32px","padding":"2px 6px","font-size":"13px"}
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annees, (a) => {
            return (_openBlock(), _createElementBlock("option", {
              key: a,
              value: a
            }, _toDisplayString(a), 9, _hoisted_4))
          }), 128))
        ], 40, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.periodeStore.mode === 'plage')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_VueDatePicker, {
              modelValue: _ctx.dateDebut,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateDebut) = $event)),
                _ctx.onDebutChange
              ],
              "enable-time-picker": false,
              format: "dd/MM/yyyy",
              placeholder: "Début",
              clearable: false,
              "auto-apply": ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("span", {
            class: "text-secondary",
            style: {"font-size":"12px"}
          }, "→", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_VueDatePicker, {
              modelValue: _ctx.dateFin,
              "onUpdate:modelValue": [
                _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dateFin) = $event)),
                _ctx.onFinChange
              ],
              "enable-time-picker": false,
              format: "dd/MM/yyyy",
              placeholder: "Fin",
              clearable: false,
              "min-date": _ctx.dateDebut ?? undefined,
              "auto-apply": ""
            }, null, 8, ["modelValue", "min-date", "onUpdate:modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.periodeStore.mode === 'tout')
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Tout "))
      : _createCommentVNode("", true)
  ]))
}